import { TicketType } from '../../ticket/ticket.constants';
import { receivingStateName, transferringStateName } from '../tickets.state';
import { ticketOverviewComponent } from './ticketOverview.component';

export const transferringListStateName = `${transferringStateName}.list`;

export const transferringListState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: transferringListStateName,
    url: '/ticketOverview?page?filter',
    component: ticketOverviewComponent.name,
    data: { requiresAuth: true },
    resolve: {
      maybeRedirectToNewUi: (appConfig, $window, envService) => {
        const { ui } = appConfig;
        if (ui.v2UI.oldBank && !envService.isLocalhost()) {
          $window.location.href = '/v2/transferring/ticketOverview';
        }
      },
      ticketsType: () => TicketType.Transferring,
    },
  });
};

export const receivingListStateName = `${receivingStateName}.list`;

export const receivingListState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    name: receivingListStateName,
    url: '/ticketOverview?page?searchTerm?product',
    reloadOnSearch: false,
    component: ticketOverviewComponent.name,
    data: { requiresAuth: true },
    resolve: {
      maybeRedirectToNewUi: (appConfig, $window, envService, $stateParams) => {
        const { ui } = appConfig;
        if (ui.v2UI.newBank && !envService.isLocalhost()) {
          $window.location.href = `/v2/receiving/ticketOverview?product=${
            $stateParams.product || 'KWH'
          }`;
        }
      },
      ticketsType: () => TicketType.Receiving,
    },
  });
};
